export default __webpack_public_path__ + "static/img5_follow_up_action-6cf824078a573b517db9d0658ab1b698.png";